import React from 'react';

import ErrorReporter from '@lyearn/core/utils/ErrorReporter';
import { useTranslation } from '@lyearn/i18n';
import { AlertDialog, DialogNotes } from '@lyearn/molecules';
import { Typography } from '@lyearn/ui';

import { UpdateDataDialogProps } from './types';

const UpdateDataDialog: React.FC<UpdateDataDialogProps> = (props) => {
  const { updateData, onClose, getUpdateItems, getDescription } = props;
  const { t } = useTranslation();

  if (!updateData) {
    ErrorReporter.error(new Error('[Bulk Import] Update data missing.'));
    return null;
  }

  const updateDataItems = getUpdateItems?.(t, updateData);

  const newDataItems = updateDataItems?.map(({ Icon, label, suffix }) => {
    const newLabel = (
      <>
        {label}{' '}
        <Typography as="span" color="text-text-secondary" variant="body-short-02">
          {suffix}
        </Typography>
      </>
    );

    return {
      Icon,
      label: newLabel,
    };
  });

  return (
    <AlertDialog
      header={{
        title: t('Common:BulkImport.ImportData.ImportSuccessful'),
        description: getDescription
          ? getDescription(t, updateData)
          : t('Common:BulkImport.ImportData.ImportSuccessfulDescription'),
      }}
      primaryAction={{
        label: t('Common:GotIt'),
        onClick: onClose,
      }}
      secondaryAction="hidden"
      onClose={onClose}>
      {newDataItems?.length ? <DialogNotes items={newDataItems} /> : null}
    </AlertDialog>
  );
};

export default UpdateDataDialog;
